<div class="modal-body p-0 basic-check-box-select-container pb-4">
  <div class="row m-0 mt-3">
    <div class="col-12 col-md-7 px-4 pr-md-0 bg-white" *ngIf="suggestionList && suggestionList.length>0">
      <div class="bg-white rounded-corners-12 checkbox-select-content">
        <div class="modal-header d-block px-3 pt-3 rounded-0">
          <p class="heading-4 mb-3">
            <span class="color-grey-700">{{title}}</span>
          </p>
          <div class="position-relative custom-dropdown">
            <span class="icon-left">
              <img src="assets/themes/icons/Search.svg" alt="search" />
            </span>
            <input [(ngModel)]="userFilter.name" [placeholder]="filterPlaceholder" />
            <span class="icon-right">
              <img src="assets/themes/icons/cancel.svg" width="16" height="16" alt="clear search"
                *ngIf="userFilter.name" (click)="resetSearchBox()" />
            </span>
          </div>
          <small class="text-danger">
            {{maxLimitErrorMsg}}
          </small>
        </div>
        <div class="modal-body pl-0 pr-2">
          <div class="ps position-relative specialty-side-height" [perfectScrollbar]="config">
            <!--  new design -->
            <div *ngIf="" class='text-center w-100'>
              <img src="assets/themes/images/primary-loader.gif" width="20" height="20" id="loadmore_post">
            </div>
            <!-- list -->
            <div class="clearfix py-1 my-1 pl-3" *ngFor="let suggestion of suggestionList  | filterBy: userFilter">
              <label class="specialty-card cursor-pointer clearfix mb-0 py-2 px-2" [id]="'SPECIALITY-' + suggestion?.id">
                <div class="specialty-img float-left mr-2">
                  <img alt="specialty img" class="specialty-img" [src]="suggestion.logo"
                    onerror="this.src='assets/themes/icons/banner-placeholder.svg'">
                </div>
                <div class="float-left w-75 d-flex align-items-center">
                  <p class="secondary-paragraph ellipsis" [ngClass]="{'color-black-700': selectedList.length>0} ">
                    {{suggestion.name}}</p>
                </div>
                <div class="float-right">
                  <!-- checkbox -->
                  <label class="checkbox">
                    <input type="checkbox" value="{{suggestion.id}}" [checked]="isSelected(suggestion)"
                      (click)="add($event,suggestion)" />
                    <span></span>
                  </label>
                </div>
              </label>
            </div>

            <div class="mt-2 mr-2 ml-2 text-center paragraph-bold"
              *ngIf="(suggestionList  | filterBy: userFilter).length === 0 ">
              <img class="mb-3" src="assets/themes/icons/no-search-result.svg" alt="no-search-result" /><br />
              {{noDataFoundLabel}}
            </div>

            <!--end list-->
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-5 bg-white py-3" *ngIf="selectedList && selectedList.length>0">
      <p class="heading-4 mb-1">
        {{title}}
      </p>
      <div *ngFor="let selected of selectedList">
        <p class="chip small icon-position-right my-1 bg-speciality bg-grey-700">
          <span class="mr-3 ellipsis">{{selected.name}}</span>
          <img src="assets/themes/icons/chip-close.svg" alt="close icon" (click)="remove(selected)"
            class="cursor-pointer close-icon" />
        </p>
      </div>

    </div>
  </div>
</div>